import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ConfirmationModal from 'widgets/Modal/ConfirmationModal';

export default class CancelOrderChangesWarning extends PureComponent {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onWarningConfirmed: PropTypes.func.isRequired,
    onWarningClosed: PropTypes.func.isRequired,
  }

  render() {
    const { visible, onWarningClosed, onWarningConfirmed } = this.props;

    if (!visible) {
      return null;
    }

    return (
      <ConfirmationModal
        title="Cancel changes?"
        onConfirm={onWarningConfirmed}
        onConfirmLabel="Yes"
        onCancel={onWarningClosed}
        onCancelLabel="No"
        className="mo-warningModal"
        mainViewScrollable
      >
        <p>
          If you cancel now, all the changes made to your order will be lost.
          Are you sure you want to cancel?
        </p>
      </ConfirmationModal>
    );
  }
}
